import React, { ReactElement, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import { CATEGORY_CONFIG } from 'screens/dashboard/categoryConfig';
import { WidgetCategoryContext } from 'screens/dashboard/components/WidgetCategoryContext';
import styles from './Box.module.scss';

export type Props = {
    title?: string;
    subTitle?: string;
    subTitleTooltip?: string;
    renderOptions?: ReactElement;
    styles?: any;
    bodyClassName?: string;
} & React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const Box = ({ children, renderOptions, title, subTitle, subTitleTooltip, bodyClassName, ...props }: Props) => {
    const { t } = useTranslation();
    const category = useContext(WidgetCategoryContext);
    const categoryCfg = category ? CATEGORY_CONFIG[category] : null;
    const CategoryIcon = categoryCfg?.icon;
    const titleTooltip = categoryCfg ? (subTitleTooltip || subTitle) : undefined;
    const [categoryTooltipId] = useState(() => `box-category-${Math.random().toString(36).slice(2, 10)}`);
    const categoryLabel = categoryCfg ? (t(categoryCfg.labelKey as any) as string) : '';

    return (
        <div {...props} className={`${styles.container} ${props.className || ''}`}>
            {(title || renderOptions) && <div className={styles.header}>
                <div className={styles.headerTitle}>
                    {categoryCfg ? (
                        <div className={`${styles.titleWrapper} ${titleTooltip ? styles.titleHoverable : ''}`}>
                            {CategoryIcon && (
                                <>
                                    <span
                                        className={styles.categoryIconWrapper}
                                        data-tip={categoryLabel}
                                        data-for={categoryTooltipId}
                                    >
                                        <CategoryIcon className={styles.categoryIcon} />
                                    </span>
                                    <ReactTooltip id={categoryTooltipId} effect="solid" place="right" />
                                </>
                            )}
                            <span className={styles.titleText}>{title}</span>
                            {titleTooltip ? (
                                <div className={styles.titleTooltip}>{titleTooltip}</div>
                            ) : null}
                        </div>
                    ) : (
                        <>
                            <div>{title}</div>
                            {subTitle ? (
                                <div className={styles.subTitleWrapper}>
                                    <span className={`${styles.subTitle} ${subTitleTooltip ? styles.subTitleHoverable : ''}`}>
                                        {subTitle}
                                    </span>
                                    {subTitleTooltip ? (
                                        <div className={styles.subTitleTooltip}>{subTitleTooltip}</div>
                                    ) : null}
                                </div>
                            ) : ''}
                        </>
                    )}
                </div>
                {renderOptions && <div className={styles.headerOptions}>{renderOptions}</div>}
            </div>}
            <div style={props.styles ?? props.styles} className={bodyClassName || ''}>
                {children}
            </div>
        </div>
    );
};

export default Box;
